export const API_URL = "https://www.papskorea.com";
